var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgServersideIconCloseBlack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "19.36 19.36 11.26 11.26",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HILFSLINIEN"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_UMGEWANDELT"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#525861",
    d: "M25.885,25l4.558-4.558c0.243-0.244,0.243-0.641,0-0.885c-0.244-0.244-0.641-0.244-0.885,0L25,24.115 l-4.558-4.558c-0.244-0.244-0.641-0.244-0.885,0c-0.243,0.244-0.243,0.641,0,0.885L24.115,25l-4.558,4.558 c-0.243,0.244-0.243,0.641,0,0.885c0.122,0.122,0.282,0.183,0.442,0.183s0.32-0.061,0.442-0.183L25,25.885l4.558,4.558 c0.122,0.122,0.282,0.183,0.442,0.183s0.32-0.061,0.442-0.183c0.243-0.244,0.243-0.641,0-0.885L25.885,25z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_PFADE",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close-2_2_",
    transform: "translate(518 3423)",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linie_1_2_",
    fill: "none",
    stroke: "#363A40",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    x1: -498,
    y1: -3393,
    x2: -488,
    y2: -3403
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_2_2_",
    fill: "none",
    stroke: "#363A40",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    x1: -488,
    y1: -3393,
    x2: -498,
    y2: -3403
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "BESCHRIFTUNG"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgServersideIconCloseBlack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/serverside-icon-close-black.f57dc6c6.svg";
export { ForwardRef as ReactComponent };